import { render, staticRenderFns } from "./TiersTable.vue?vue&type=template&id=2aa8ea4f&scoped=true&"
import script from "./TiersTable.vue?vue&type=script&lang=js&"
export * from "./TiersTable.vue?vue&type=script&lang=js&"
import style0 from "./TiersTable.vue?vue&type=style&index=0&id=2aa8ea4f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa8ea4f",
  null
  
)

export default component.exports